var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.storeData.days),function(day){return _c('store-day',{key:day.id,attrs:{"day":day,"add-range-text":_vm.addRangeText,"base-properties":_vm.baseProperties}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }